/**
 * dom.js — Carousel Composer scroll and flash helpers.
 *
 * The portal's <main> is the scroll container, not the window, so everything the
 * artifact did with window.scrollTo goes through the page root's scroll parent.
 */

export function pageRoot() {
  return document.querySelector('.cc-page');
}

export function scrollParent(el) {
  let n = el && el.parentElement;
  while (n) {
    const oy = getComputedStyle(n).overflowY;
    if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight) return n;
    if (n.tagName === 'MAIN' && (oy === 'auto' || oy === 'scroll')) return n;
    n = n.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}

export function scrollPageTop(smooth) {
  const root = pageRoot();
  if (!root) return;
  const sc = scrollParent(root);
  sc.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
}

// Runs fn once React has committed the store change that preceded it.
export function afterRender(fn) {
  requestAnimationFrame(() => requestAnimationFrame(fn));
}

export function slideCard(si) {
  return document.querySelector('.cc-page .slide[data-si="' + si + '"]');
}

export function scrollToSlide(si, highlight) {
  const cardEl = slideCard(si);
  if (!cardEl) return;
  cardEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  if (highlight) {
    cardEl.style.borderColor = 'var(--accent)';
    setTimeout(() => { cardEl.style.borderColor = ''; }, 700);
  }
}

export function scrollToLastSlide() {
  const all = document.querySelectorAll('.cc-page .slide');
  if (all.length) all[all.length - 1].scrollIntoView({ behavior: 'smooth', block: 'center' });
}

export function tileEl(id) {
  return document.querySelector('.cc-page .tile[data-id="' + id + '"]');
}

export function revealTile(id) {
  const el = tileEl(id);
  if (!el) return;
  el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  el.classList.remove('flash');
  void el.offsetWidth;
  el.classList.add('flash');
}
